export enum Locale {
  EN = 'en',
  MY = 'my',
}

export enum Language {
  ENG = 'ENG',
  BMY = 'BMY',
}
